var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup26X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H8.5L11.5 11.5L1 8L0.5 10V12.5L1 15L3 18.5L8 21.5H12L16 20.5L20 17L22 11L20.5 6L17 2L12.5 0.5Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5L8.5 0.5L4.5 2.5L2 5L0.5 8L11.5 11.5Z",
    fill: "#97A2C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.0109C4.93827 22.0109 0 17.0702 0 11.0055C0 4.94073 4.93827 0 11 0C17.0617 0 22 4.94073 22 11.0055C22 17.0702 17.0617 22.0109 11 22.0109ZM11 0.629945C5.28395 0.629945 0.617284 5.28659 0.617284 11.0178C0.617284 16.7491 5.27161 21.4057 11 21.4057C16.7284 21.4057 21.3827 16.7491 21.3827 11.0178C21.3827 5.28659 16.7284 0.629945 11 0.629945Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8024 11.8331L0.567871 8.18927L0.765403 7.60873L10.9136 10.8943L8.16046 0.617601L8.75306 0.457031L11.8024 11.8331Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26X);
export default __webpack_public_path__ + "static/media/Group26x.c6b9a66d9d7a2c549131d2a06410edca.svg";
export { ForwardRef as ReactComponent };